<template>
  <div>
    <NbCard id="sms">
      <template #header>
        <div class="d-flex align-items-center gap-2">
          <h3 class="heading-3 m-0">
            {{ $t("settingsPage.sendSms") }}
          </h3>

          <NbBadge v-if="send_sms" :text="$t('active')" type="success" />
          <NbBadge v-else :text="$t('inactive')" type="error" />
        </div>
      </template>
      <template #body>
        <p class="body-3">
          {{ $t("settingsPage.textSendSms") }}
        </p>

        <p class="body-3">
          {{ $t("settingsPage.sendFromYourCompanyPhoneNumber") }}
        </p>

        <p class="body-3">
          {{ $t("settingsPage.smsCostsWillBeCharged") }}
        </p>

        <NbButton @click="showModal()" class="mr-auto mt-4">
          {{ send_sms ? $t("disable") : $t("enable") }}
        </NbButton>
      </template>
    </NbCard>

    <Modal v-model="isModalOpen">
      <ModalHeader>
        <ModalTitle>
          {{ $t("confirmation") }}
        </ModalTitle>
      </ModalHeader>

      <div v-if="send_sms">
        <p class="body-3">
          <i18n path="settingsPage.disableSmsText">
            <template #link>
              <router-link
                class="link-1"
                to="/notifications/tracking-rule-notifications"
              >
                {{ $t("trackingRuleNotificationsPage.title") }}
              </router-link>
            </template>
          </i18n>
        </p>
      </div>

      <div v-else>
        <p class="body-3">
          {{ $t("settingsPage.enableSmsText") }}
        </p>
        <p class="body-3">
          {{ $t("settingsPage.pleaseConfirmAdditionalCosts") }}
        </p>
      </div>

      <ModalFooter class="d-flex justify-content-end gap-2">
        <ModalClose />
        <NbButton
          v-if="sms_loader"
          disabled
          class="d-flex gap-2 align-items-center"
        >
          <Spinner />
          {{
            send_sms
              ? $t("settingsPage.disabling")
              : $t("settingsPage.enabling")
          }}
        </NbButton>
        <NbButton v-else @click="updateSMS()">
          {{ send_sms ? $t("disable") : $t("enable") }}
        </NbButton>
      </ModalFooter>
    </Modal>
  </div>
</template>

<script>
import NbCard from "@/components/cards/NbCard.vue";
import NbButton from "@/components/buttons/NbButton.vue";
import NbBadge from "@/components/alerts/NbBadge.vue";
import Spinner from "@/components/Spinner.vue";
import Modal from "@/components/modal/Modal.vue";
import ModalHeader from "@/components/modal/ModalHeader.vue";
import ModalTitle from "@/components/modal/ModalTitle.vue";
import ModalFooter from "@/components/modal/ModalFooter.vue";
import ModalClose from "@/components/modal/ModalClose.vue";

import NotificationSettingsService from "@/services/NotificationSettingsService";

const notificationSettingsService = new NotificationSettingsService();

export default {
  name: "SendSms",
  components: {
    NbCard,
    NbButton,
    NbBadge,
    Spinner,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalFooter,
    ModalClose,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      send_sms: this.settings.send_sms,
      sms_loader: false,
      isModalOpen: false,
    };
  },
  methods: {
    showModal() {
      this.isModalOpen = true;
    },
    async updateSMS() {
      try {
        this.sms_loader = true;
        await notificationSettingsService.updateSMS({
          send_sms: !this.settings.send_sms,
        });

        this.send_sms = !this.settings.send_sms;
      } finally {
        this.sms_loader = false;
        this.isModalOpen = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
